// The label matches the first baseline header of the "Download Data" export
// (`CsvExportHeaders.EntityIdHeader` in eid-insurance), so an export round-trips through the
// bulk import without an alias.
export const ENTITY_ID_COLUMN_KEY = 'id';
export const ENTITY_ID_COLUMN_LABEL = 'Entity ID';
